"use client";
import { MOTION_DURATIONS as e } from "../../tokens/motion-durations/MotionDurations.js";
const r = Object.freeze({
  in: e.normal,
  out: e.normal * 2
});
export {
  r as MODAL_DURATIONS
};
